<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3MTari/tc-custom/9781467466097.jpg?1730410281305" alt="This image is the cover for the book The Eerdmans Dictionary of Early Judaism"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Eerdmans Dictionary of Early Judaism
      </h1>
      <p class="bookDescription body article font2">
        <p>The Dictionary of Early Judaism is the first reference work devoted exclusively to Second Temple Judaism (fourth century b.c.e. through second century c.e.). <br/><br/>The first section of this substantive and incredible work contains thirteen major essays that attempt to synthesize major aspects of Judaism in the period between Alexander and Hadrian. The second — and significantly longer — section offers 520 entries arranged alphabetically. Many of these entries have cross-references and all have select bibliographies. Equal attention is given to literary and nonliterary (i.e. archaeological and epigraphic) evidence and New Testament writings are included as evidence for Judaism in the first century c.e. Several entries also give pertinent information on the Hebrew Bible. <br/><br/>The Dictionary of Early Judaism is intended to not only meet the needs of scholars and students — at which it succeeds admirably — but also to provide accessible information for the general reader. It is ecumenical and international in character, bringing together nearly 270 authors from as many as twenty countries and including Jews, Christians, and scholars of no religious affiliation.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John J. Collins, Daniel C. Harlow
      </h2>
      
      <p class="authorDescription body article"> &#160; <B>John J. Collins</B>&#160;is Holmes Professor of Old Testament Criticism and Interpretation at Yale Divinity School and a recognized expert in early Judaism and the Dead Sea Scrolls. His many other works include&#160;<I>The Apocalyptic Imagination</I>,&#160;<I>Beyond the Qumran Community</I>,&#160;<I>The Scepter and the Star</I>, and (with Daniel C. Harlow)&#160;<I>The Eerdmans Dictionary of Early Judaism</I>. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?43f66e8f